import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { Navigate } from 'react-router';
import { Main } from 'src/layouts/main/Main';
import { Protected } from 'src/layouts/protected/Protected';

const Band = lazy(() => import('src/modules/band/band.page'));
const Bands = lazy(() => import('src/modules/bands/bands.page'));
const Login = lazy(() => import('src/modules/login/login.page'));
const NotFound = lazy(() => import('src/modules/not-found/not-found.page'));
const Privacy = lazy(() => import('src/modules/privacy/privacy.page'));
const Song = lazy(() => import('src/modules/song/song.page'));
const Terms = lazy(() => import('src/modules/terms/terms.page'));

export const routes: RouteObject[] = [
  {
    element: <Main />,
    children: [
      { path: '/login', element: <Login /> },
      { path: '/terms', element: <Terms /> },
      { path: '/privacy', element: <Privacy /> },
      {
        element: <Protected />,
        children: [
          { path: '/', element: <Navigate to="/bands" replace /> },
          { path: '/bands', element: <Bands /> },
          { path: '/bands/:slug', element: <Band /> },
          { path: '/bands/:band/songs/:song', element: <Song /> },
          { path: '/bands/:band/songs/:song/:mode', element: <Song /> },
          { path: '*', element: <NotFound /> },
        ],
      },
    ],
  },
];
